import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import type { SiteControllerSettingTLLincolnFormModelMethodsType } from "@/components/features/settings/site-controller/model/tl-lincoln/use-case/use-create-model/methods";

import { SettingsSiteControllerTlLincolnMainSection } from "./section";
import { SettingsSiteControllerBase } from "../../../_shared/base";

import type { SiteControllerSettingBaseFormModel } from "../../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingTllFormModel } from "../../../../../model/tl-lincoln/type";

type Props = {
	hotelID: string;
	baseViewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	tlLincolnViewModel: SiteControllerSettingTllFormModel["ViewModel"];
	siteControllerSettingTLLincolnFormModelMethods: SiteControllerSettingTLLincolnFormModelMethodsType;

	queryData: SiteControllerSettingBaseFormModel["QueryData"];
};

export const SettingsSiteControllerTLLincolnMainIsland = ({
	hotelID,
	baseViewModel,
	siteControllerSettingBaseFormModelMethodsType, //

	tlLincolnViewModel,
	siteControllerSettingTLLincolnFormModelMethods,

	queryData,
}: Props) => {
	return (
		<FeatureIslandContainer>
			<FeatureIslandMainWithBackGround islandTitle="基本設定">
				<SettingsSiteControllerBase
					hotelID={hotelID}
					siteControllerType={baseViewModel.siteControllerType}
					siteControllerSettingBaseFormModelMethods={siteControllerSettingBaseFormModelMethodsType}
				/>
				<SettingsSiteControllerTlLincolnMainSection
					tlLincolnViewModel={tlLincolnViewModel}
					siteControllerSettingTLLincolnFormModelMethods={siteControllerSettingTLLincolnFormModelMethods}
					roomKVList={queryData.roomKVList}
				/>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

SettingsSiteControllerTLLincolnMainIsland.displayName = "SettingsSiteControllerTLLincolnMainIsland";
